import { Box, Link, Typography } from "@material-ui/core";
import React, { useMemo } from "react";
import { useBoldStyles } from "../../../../themes/style-hooks";
import { useSavedJobPosts } from "../../job-posts/hooks";
import { useSavedJobRequests } from "../hooks";

type SavedJobRequestHighlightsProps = {};

export const SavedJobRequestHighlights: React.FC<
  SavedJobRequestHighlightsProps
> = () => {
  const boldStyles = useBoldStyles();

  const { data: savedJobRequests, isLoading: isLoadingJobRequests } =
    useSavedJobRequests();
  const { data: savedJobPosts, isLoading: isLoadingJobPosts } =
    useSavedJobPosts();

  const savedJobRequestsCount = useMemo(
    () => savedJobRequests?.length ?? 0,
    [savedJobRequests?.length]
  );

  const savedJobPostsCount = useMemo(
    () => savedJobPosts?.length ?? 0,
    [savedJobPosts?.length]
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      pt={10}
      gridRowGap={12}
    >
      <Typography variant="subtitle1" className={boldStyles.root}>
        Saved Job Requests & Posts
      </Typography>
      <Box fontSize={18}>
        <Link
          href="/job-requests/saved"
          underline="hover"
          style={
            !savedJobRequestsCount
              ? {
                  pointerEvents: "none",
                  textDecoration: "none",
                  color: "white",
                }
              : {}
          }
        >
          {savedJobRequestsCount} Job Request(s)
        </Link>
      </Box>
      <Box fontSize={18}>
        <Link
          href="/job-posts/saved"
          underline="hover"
          style={
            !savedJobPostsCount
              ? {
                  pointerEvents: "none",
                  textDecoration: "none",
                  color: "white",
                }
              : {}
          }
          data-cy="saved-jobs"
        >
          {savedJobPostsCount} Job Post(s)
        </Link>
      </Box>
    </Box>
  );
};
